var render = function render(){var _vm=this,_c=_vm._self._c;return _c('course-image-uploader',{attrs:{"value":_vm.image},on:{"input":_vm.onImageInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }